import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Hangul from 'hangul-js';

import { List, Map, fromJS } from 'immutable';
import { getFormValues, isValid, reset } from 'redux-form';

import * as validFunc from 'libs/validation';
import * as tagActions from 'modules/tag';
import * as currentStatusActions from 'modules/currentStatus';

import { Tag } from 'components';

class CtTag extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checkedColorAddTag: 'red',
      isLoading: false,
      isClicked: false
    };

    this.onAddTag = this.onAddTag.bind(this);
    this.onDeleteTag = this.onDeleteTag.bind(this);
    this.onClickTag = this.onClickTag.bind(this);
    this.onClickEachTag = this.onClickEachTag.bind(this);
    // this.onCheckOrTag = this.onCheckOrTag.bind(this);
    // this.onCheckAndTag = this.onCheckAndTag.bind(this);
    this.onToggleModal = this.onToggleModal.bind(this);
    this.onToggleTagEdit = this.onToggleTagEdit.bind(this);
    this.onToggleTagInitial = this.onToggleTagInitial.bind(this);
    this.onKeypressTagName = this.onKeypressTagName.bind(this);
    this.onCheckColorAdd = this.onCheckColorAdd.bind(this);
    this.onCheckColorEdit = this.onCheckColorEdit.bind(this);
  }

  componentDidMount() {
    this.onGetTag();
  }

  // 훈련 선택시 대상자 rerender 처리
  componentDidUpdate(prevProps, prevState) {
    const { needReload, tagParam } = this.props;
    if (
      (needReload && !this.state.isLoading) ||
      // 필터
      tagParam !== prevProps.tagParam
    ) {
      this.onGetTag();
    }
  }

  onGetTag = async () => {
    try {
      if (!this.state.isLoading) {
        this.setState({ isLoading: true });

        const { TagActions, tagParam, CurrentStatusActions } = this.props;

        const param = {
          filter: JSON.stringify(tagParam.get('filter'))
          // sort: JSON.stringify(tagParam.get('sort')),
          // offset: tagParam.get('limit') * page,
          // limit: tagParam.get('limit')
        };

        await TagActions.getTag(param);
        CurrentStatusActions.clearTag();
        this.setState({ isLoading: false });
      }
    } catch (e) {
      console.log(e);
    }
  };

  // 성공 실패시 알림창
  onToggleSnackbar = message => {
    const { CurrentStatusActions } = this.props;
    setTimeout(() => {
      CurrentStatusActions.toggleSnackbar({ message: '' });
    }, 5000);

    CurrentStatusActions.toggleSnackbar({ message });
  };

  // 태그 추가
  onAddTag = async () => {
    this.setState({ isClicked: true });
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    const { CurrentStatusActions, TagActions, formTagAddStore, formTagAdd, isValidFormTagAdd } = this.props;

    try {
      if (!!formTagAdd && isValidFormTagAdd && !await validFunc.tagNameValidate(formTagAdd.tagName)) {
        await TagActions.postTag({
          tagName: formTagAdd.tagName,
          tagInitial: Hangul.disassemble(formTagAdd.tagName)[0],
          color: this.state.checkedColorAddTag
        });

        this.onToggleModal('');
        this.onToggleSnackbar(
          formTagAdd.tagName + ' ' + defineMessages(formatMessage({ id: 'CtTag_1', defaultMessage: '태그 등록' }))
        );
      } else {
        window.markFieldValidate(formTagAddStore, 'formTagAdd');
      }
      setTimeout(() => {
        this.setState({ isClicked: false });
      }, 100);
    } catch (e) {
      console.log(e);
    }
  };

  // 태그 삭제
  onDeleteTag = async () => {
    this.setState({ isClicked: true });

    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { TagActions, CurrentStatusActions, formTagDelete, isValidFormTagDelete } = this.props;

    try {
      if (isValidFormTagDelete) {
        await TagActions.deleteTag({
          tagNo: formTagDelete.tagNo
        });

        CurrentStatusActions.initialTag();
        this.onToggleSnackbar(
          formTagDelete.tagName + ' ' + defineMessages(formatMessage({ id: 'CtTag_2', defaultMessage: '태그 삭제' }))
        );
        this.onToggleModal('');
      }

      setTimeout(() => {
        this.setState({ isClicked: false });
      }, 100);
    } catch (e) {
      console.log(e);
    }
  };

  // 태그 전체 삭제
  onDeleteAllTag = async () => {
    this.setState({ isClicked: true });

    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { TagActions, CurrentStatusActions } = this.props;

    try {
      await TagActions.deleteAllTag();

      CurrentStatusActions.initialTag();
      this.onToggleSnackbar(defineMessages(formatMessage({ id: 'CtTag_2', defaultMessage: '태그 삭제' })));
      this.onToggleModal('');

      setTimeout(() => {
        this.setState({ isClicked: false });
      }, 100);
    } catch (e) {
      console.log(e);
    }
  };

  // 모든 대상자, 태그가 없는 대상 선택
  onClickTag = which => {
    const { CurrentStatusActions } = this.props;

    CurrentStatusActions.clearTag();
    CurrentStatusActions.changeTag({
      name: 'selectedTag',
      value: List([which])
    });
  };

  // 태그 선택 처리
  onClickEachTag = (e, tagNo, tagName, color) => {
    if (e.target.nodeName === 'INPUT') {
      return false;
    }
    const { CurrentStatusActions, isEditMode, currentTag, ReduxFormReset } = this.props;

    // 편집 모드
    if (isEditMode) {
      // 선택한 태그 정보 저장
      CurrentStatusActions.clearTag();
      CurrentStatusActions.changeTag({
        name: 'isEditData',
        value: Map({ tagNo, tagName, tagInitial: Hangul.disassemble(tagName)[0], color })
      });

      // 태그명 수정
      if (e.target.className === 'editMode-tagName') {
        ReduxFormReset('formTagEdit');

        CurrentStatusActions.changeTag({
          name: 'isTagNameEdit',
          value: true
        });
      }
      // 일반적인 태그 선택
    } else {
      // 선택한 태그 정보 저장
      CurrentStatusActions.selectTag({
        tagNo: tagNo,
        isMultiSelect: currentTag.get('isMultiSelect'),
        isMultiAndSelect: currentTag.get('isMultiAndSelect')
      });
    }
  };

  // 태그 다중 선택(OR)
  onCheckOrTag = () => {
    const { TagActions, CurrentStatusActions, currentTag } = this.props;

    // 태그 수정 모드 종료
    TagActions.toggleEditMode(false);

    CurrentStatusActions.clearTag();
    // 만약 다중선택되있는 상태에서 버튼을 해제하면 가장 마지막에 선택한 tag만 남긴다
    if (currentTag.get('isMultiSelect')) {
      CurrentStatusActions.selectLastTag();
    }

    CurrentStatusActions.changeTag({
      name: 'isMultiAndSelect',
      value: false
    });

    CurrentStatusActions.changeTag({
      name: 'isMultiSelect',
      value: !currentTag.get('isMultiSelect')
    });

    CurrentStatusActions.changeTag({
      name: 'multiType',
      value: 'or'
    });
  };

  // 태그 다중 선택(AND)
  onCheckAndTag = () => {
    const { TagActions, CurrentStatusActions, currentTag } = this.props;

    // 태그 수정 모드 종료
    TagActions.toggleEditMode(false);

    CurrentStatusActions.clearTag();
    // 만약 다중선택되있는 상태에서 버튼을 해제하면 가장 마지막에 선택한 tag만 남긴다
    if (currentTag.get('isMultiAndSelect')) {
      CurrentStatusActions.selectLastTag();
    }

    CurrentStatusActions.changeTag({
      name: 'isMultiSelect',
      value: false
    });

    CurrentStatusActions.changeTag({
      name: 'isMultiAndSelect',
      value: !currentTag.get('isMultiAndSelect')
    });

    CurrentStatusActions.changeTag({
      name: 'multiType',
      value: 'and'
    });
  };

  // 모달 처리
  onToggleModal = viewType => {
    // (태그 추가 모달) 초기화
    const { ReduxFormReset } = this.props;
    ReduxFormReset('formTagAdd');
    this.setState({ checkedColorAddTag: 'red' });

    const { CurrentStatusActions } = this.props;
    CurrentStatusActions.onToggleModal({ viewType: viewType });
  };

  // 태그 검색 모드
  onSearchActive = () => {
    const { TagActions, CurrentStatusActions, tagParam } = this.props;
    TagActions.toggleSearchActive();
    CurrentStatusActions.clearTag();

    // 검색 된 상태일 경우 검색어 입력
    CurrentStatusActions.changeTag({ name: 'searchText', value: tagParam.getIn(['filter', 'tagName']) });
  };

  // 태그 검색어 입력
  onChangeSearch = e => {
    const { CurrentStatusActions } = this.props;
    CurrentStatusActions.changeTag({ name: 'searchText', value: e.target.value });
  };

  onKeyupSearch = e => {
    if (e.key.toLowerCase() === 'enter') {
      this.onSearch();
    }
  };

  // 태그 검색 취소
  onClearSearch = () => {
    const { CurrentStatusActions } = this.props;
    CurrentStatusActions.changeTag({ name: 'searchText', value: '' });
    setTimeout(() => {
      this.onSearch();
    }, 100);
  };

  // 태그 검색
  onSearch = () => {
    const { TagActions, CurrentStatusActions, searchText } = this.props;

    CurrentStatusActions.selectTag({ tagNo: 'all-tag', isMultiSelect: false });
    // CurrentStatusActions.initialTag();
    TagActions.changeParam({
      name: 'filter',
      value: !!searchText ? fromJS({ tagName: searchText }) : Map({})
    });
  };

  // 태그 편집 모드 전환
  onToggleTagEdit = () => {
    const { TagActions, CurrentStatusActions } = this.props;
    TagActions.toggleEditMode();
    CurrentStatusActions.clearTag();
  };

  // 태그의 초성별 영역 열기/닫기
  onToggleTagInitial = tagInitial => {
    const { TagActions, CurrentStatusActions } = this.props;

    if (typeof tagInitial !== 'undefined') {
      TagActions.toggleTagInitial({ tagInitial: tagInitial });
    } else {
      //
      TagActions.toggleAllTagInitial();
    }
    CurrentStatusActions.clearTag();
  };

  // 태그명 수정
  onSaveTagName = async () => {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { TagActions, CurrentStatusActions, currentTag, formTagEdit, isValidFormTagEdit } = this.props;

    try {
      if (
        !!formTagEdit &&
        isValidFormTagEdit &&
        !await validFunc.tagNameValidate(formTagEdit.tagName) &&
        currentTag.getIn(['isEditData', 'tagName']) !== formTagEdit.tagName
      ) {
        const param = {
          tagNo: currentTag.getIn(['isEditData', 'tagNo']),
          tagName: formTagEdit.tagName,
          tagInitial: Hangul.disassemble(formTagEdit.tagName)[0],
          beforeTagInitial: Hangul.disassemble(currentTag.getIn(['isEditData', 'tagName']))[0]
        };

        await TagActions.putTag(param);

        CurrentStatusActions.clearTag();
        this.onToggleSnackbar(
          defineMessages(formatMessage({ id: 'CtTag_3', defaultMessage: '태그명' })) +
          " '" +
          currentTag.getIn(['isEditData', 'tagName']) +
          "'" +
          defineMessages(formatMessage({ id: 'CtTag_4', defaultMessage: '에서' })) +
          " '" +
          formTagEdit.tagName +
          "'" +
          defineMessages(formatMessage({ id: 'CtTag_5', defaultMessage: '로 수정' }))
        );
      }

      // focus
    } catch (e) {
      console.log(e);
    }
  };

  // 태그명에서 엔터 입력시
  onKeypressTagName = e => {
    if (e.key.toLowerCase() === 'enter') {
      this.onSaveTagName();
    }
  };

  // 태그명 수정 취소
  onCancelTagName = () => {
    const { CurrentStatusActions } = this.props;

    CurrentStatusActions.clearTag();
    CurrentStatusActions.changeTag({
      name: 'isTagNameEdit',
      value: false
    });
  };

  // 태그 색상 수정
  onEditTagColor = (e, tagNo, tagName, color) => {
    const { CurrentStatusActions, isEditMode } = this.props;

    if (isEditMode) {
      // 선택한 태그 정보 저장
      CurrentStatusActions.clearTag();
      CurrentStatusActions.changeTag({
        name: 'isEditData',
        value: Map({ tagNo, tagName, tagInitial: Hangul.disassemble(tagName)[0], color })
      });

      const { currentTag } = this.props;
      // 색상 선택 dropdown
      const offsetTop = e.target.offsetTop;
      const offsetLeft = e.target.offsetLeft;

      let dropdownView = true;
      if (currentTag.getIn(['isDropdown', 'isView']) && currentTag.getIn(['isEditData', 'tagNo']) === tagNo) {
        dropdownView = false;
      }

      CurrentStatusActions.changeTag({
        name: 'isDropdown',
        value: Map({ isView: dropdownView, top: offsetTop, left: offsetLeft })
      });
    }
  };

  // 태그 삭제 모달
  onToggleDeleteTag = (tagNo, tagName, color) => {
    const { CurrentStatusActions, isEditMode } = this.props;

    if (isEditMode) {
      // 선택한 태그 정보 저장
      CurrentStatusActions.clearTag();
      CurrentStatusActions.changeTag({
        name: 'isEditData',
        value: Map({ tagNo, tagName, tagInitial: Hangul.disassemble(tagName)[0], color })
      });

      this.onToggleModal('tagDelete');
    }
  };

  // 태그 전체 삭제 모달
  onToggleDeleteAllTag = (tagNo, tagName, color) => {
    const { isEditMode } = this.props;

    this.onToggleModal('tagAllDelete');
  };

  // 태그 색상 선택 (태그 추가)
  onCheckColorAdd = color => {
    this.setState({ checkedColorAddTag: color });
  };

  // 태그 색상 선택 (태그 수정)
  onCheckColorEdit = async color => {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { TagActions, CurrentStatusActions, currentTag, isValidFormTagEdit, formTagEdit } = this.props;

    // form의 validation 통과 | 변경사항이 있을 경우에만 수정
    if (!isValidFormTagEdit || currentTag.getIn(['isEditData', 'color']) === color) {
      CurrentStatusActions.clearTag();

      return false;
    }

    try {
      await TagActions.putTag({ tagNo: currentTag.getIn(['isEditData', 'tagNo']), color });
      CurrentStatusActions.clearTag();
      this.onToggleSnackbar(
        formTagEdit.tagName + ' ' + defineMessages(formatMessage({ id: 'CtTag_6', defaultMessage: '태그 색상 수정' }))
      );
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    const { tagInitialOrdering, tagInitial, currentTag, tagDataByTagNo, isModal, isEditMode, isAllOpen, path } = this.props;
    // function
    const {
      onAddTag,
      onDeleteTag,
      onDeleteAllTag,
      onClickTag,
      onClickEachTag,
      onCheckOrTag,
      onCheckAndTag,
      onToggleModal,
      onToggleTagEdit,
      onToggleTagInitial,
      onKeypressTagName,
      onCheckColorAdd,
      onCheckColorEdit,
      onSaveTagName,
      onCancelTagName,
      onToggleDeleteTag,
      onToggleDeleteAllTag,
      onEditTagColor
    } = this;
    // 검색
    const { isSearchActive, searchText } = this.props;
    const { onSearchActive, onSearch, onChangeSearch, onKeyupSearch, onClearSearch } = this;

    const { noTagCount } = this.props;

    return (
      <Tag
        tagInitialOrdering={tagInitialOrdering}
        tagInitial={tagInitial}
        tagDataByTagNo={tagDataByTagNo}
        currentTag={currentTag}
        isAllOpen={isAllOpen}
        isModal={isModal}
        isEditMode={isEditMode}
        isClicked={this.state.isClicked}
        isLoading={this.state.isLoading}
        color={this.state.checkedColorAddTag}
        // function
        onClickTag={onClickTag}
        onCheckOrTag={onCheckOrTag}
        onCheckAndTag={onCheckAndTag}
        onAddTag={onAddTag}
        onDeleteTag={onDeleteTag}
        onDeleteAllTag={onDeleteAllTag}
        onToggleModal={onToggleModal}
        onSearchActive={onSearchActive}
        onSearch={onSearch}
        onToggleTagEdit={onToggleTagEdit}
        onToggleTagInitial={onToggleTagInitial}
        onToggleDeleteAllTag={onToggleDeleteAllTag}
        onCheckColorAdd={onCheckColorAdd}
        onCheckColorEdit={onCheckColorEdit}
        // 태그 검색
        searchProps={{
          searchText: searchText,
          isSearchActive: isSearchActive,
          onSearchActive: onSearchActive,
          onSearch: onSearch,
          onChangeSearch: onChangeSearch,
          onKeyupSearch: onKeyupSearch,
          onClearSearch: onClearSearch
        }}
        // tagItem으로 전달
        tagItemProp={{
          // 태그명 수정 저장
          onSaveTagName: onSaveTagName,
          // 태그명 수정 취소
          onCancelTagName: onCancelTagName,
          // 태그 색상 수정
          onEditTagColor: onEditTagColor,
          // 태그 삭제 모달
          onToggleDeleteTag: onToggleDeleteTag,
          // 태그 선택
          onClickEachTag: onClickEachTag,
          // 태그명 keypress
          onKeypressTagName: onKeypressTagName
        }}
        // 태그 카운트 표기 여부
        noTagCount={noTagCount}
        currentPath={path.get('current')}
      />
    );
  }
}

const mapStateToProps = state => ({
  selectedTag: state.currentStatus.getIn(['tag', 'selectedTag']),
  searchText: state.currentStatus.getIn(['tag', 'searchText']),
  currentTag: state.currentStatus.get('tag'),
  path: state.currentStatus.get('path'),
  isModal: state.currentStatus.get('isModal'),
  tagParam: state.tag.get('param'),
  needReload: state.tag.get('needReload'),
  tagInitialOrdering: state.tag.get('tagInitialOrdering'),
  tagInitial: state.tag.get('tagInitial'),
  tagDataByTagNo: state.tag.get('tagDataByTagNo'),
  isEditMode: state.tag.get('isEditMode'),
  isSearchActive: state.tag.get('isSearchActive'),
  isAllOpen: state.tag.get('isAllOpen'),
  formTagAddStore: state.form['formTagAdd'],
  formTagAdd: getFormValues('formTagAdd')(state),
  formTagEdit: getFormValues('formTagEdit')(state),
  formTagDelete: getFormValues('formTagDelete')(state),
  isValidFormTagAdd: isValid('formTagAdd')(state),
  isValidFormTagEdit: isValid('formTagEdit')(state),
  isValidFormTagDelete: isValid('formTagDelete')(state)
});

const mapDispatchToProps = dispatch => ({
  TagActions: bindActionCreators(tagActions, dispatch),
  CurrentStatusActions: bindActionCreators(currentStatusActions, dispatch),
  ReduxFormReset: bindActionCreators(reset, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtTag));



// WEBPACK FOOTER //
// ./src/script/containers/target/CtTag.js